<h2 class="h-small pb-3 title-office-puple" >결제 상세 정보</h2>

<div class="table-container row draggable-element">
  <div class="col col_data"> 
    <div class="table-wrapper table draggable-items-wrapper tb-scroll-container" draggableWrapper>
      <table class="hr-table" style="display: table">
        <thead>
          <tr>
            <th style="white-space: nowrap; text-align: center;" class="sticky-col">결제유형</th>
            <th style="white-space: nowrap; text-align: center;">결제여부</th>
            <th style="white-space: nowrap; text-align: center;">결제금액</th>
            <th style="white-space: nowrap; text-align: center;">입금계좌</th>
            <th style="white-space: nowrap; text-align: center;">입금자명</th>
            <th style="white-space: nowrap; text-align: center;">입금번호</th>
            <th style="white-space: nowrap; text-align: center;">승인번호</th>
            <th style="white-space: nowrap; text-align: center;">입금만료일</th>
            <th style="white-space: nowrap; text-align: center;">카드사명</th>
            <th style="white-space: nowrap; text-align: center;">카드번호 / 계좌번호</th>
            <th style="white-space: nowrap; text-align: center;">소유주명</th>
            <th style="white-space: nowrap; text-align: center;">결제일</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of items">
            <td class="sticky-col">{{ item.kindName }}</td>
            <td style="text-align: center;">{{ item.ispay }}</td>
            <td style="text-align: right;">{{ item.amt | setComma }}원</td>
            <td>{{ item.cardCd }}</td>
            <td>{{ item.username }}</td>
            <td style="text-align: center;">{{ item.moneyNo }}</td>
            <td style="text-align: center;">{{ item.cardAppNo }}</td>
            <td style="text-align: center;">{{ item.expDate }}</td>
            <td>{{ item.cardName }}</td>
            <td style="text-align: center;">{{ item.cardNo }}</td>
            <td>{{ item.cardHolder }}</td>
            <td style="text-align: center;">{{ item.regDate }}</td>
          </tr>
        </tbody>
        <ng-container *ngIf="totalRows < 5">
          <tbody>
            <tr *ngFor="let row of rows; index as i">
              <ng-container *ngFor="let col of cols; index as j">
                <td>
                  <span>&nbsp;</span>
                  <ng-container *ngIf="totalRows === 0 && i === 2 && j === 6">
                    <span class='h-small empty-warning'>조회된 데이타가 없습니다.</span>
                  </ng-container>
                </td>
              </ng-container>
            </tr>
          </tbody>
        </ng-container>
      </table>
    </div>
  </div>
</div>